import apiDevops from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  actions: {
    async findSystem() {
      const { data } = await apiDevops.get('devops/system');
      return data;
    },

    async findPm2Summary() {
      const { data } = await apiDevops.get('devops/pm2/summary');
      return data;
    },

    async findPm2Processos() {
      const { data } = await apiDevops.get('devops/pm2/processos');
      return data;
    },

    async findNginxStats(_, since = '24h') {
      const { data } = await apiDevops.get('devops/nginx/stats', { params: { since } });
      return data;
    },

    async findNginxInfo() {
      const { data } = await apiDevops.get('devops/nginx/info');
      return data;
    },

    async findClientesInfo(_, processos) {
      const { data } = await apiDevops.post('devops/empresa/info', { processos });
      return data;
    },
  },
};
